import { Box, Container, Typography, Breadcrumbs, Link } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

function ProfileHeader() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderBottom: "1px solid",
        borderColor: "divider",
        py: { xs: 2, sm: 3 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Breadcrumbs
            aria-label="breadcrumb"
            sx={{
              "& .MuiBreadcrumbs-separator": {
                color: "text.secondary",
              },
            }}
          >
            <Link
              underline="hover"
              color="inherit"
              href="/dashboard"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                fontSize: "0.875rem",
                fontWeight: 500,
              }}
            >
              <HomeIcon sx={{ fontSize: 16 }} />
              {t("userProfile.breadcrumbHome", "Home")}
            </Link>
            <Typography
              color="text.primary"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                fontSize: "0.875rem",
                fontWeight: 600,
              }}
            >
              <PersonIcon sx={{ fontSize: 16 }} />
              {t("userProfile.breadcrumbProfile", "Profile")}
            </Typography>
          </Breadcrumbs>
        </Box>

        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "text.primary",
            fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" },
            mb: 1,
          }}
        >
          {t("userProfile.pageTitle", "My Profile")}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            maxWidth: 600,
            lineHeight: 1.6,
          }}
        >
          {t(
            "userProfile.pageDescription",
            "Manage your personal information, certificates, and account settings."
          )}
        </Typography>
      </Container>
    </Box>
  );
}

ProfileHeader.propTypes = {};

export default ProfileHeader;
